import { datadogRum, type RumInitConfiguration } from "@datadog/browser-rum";

declare global {
  interface Window {
    DD_RUM: {
      init: (config: RumInitConfiguration) => void;
    };
  }
}

export function initDatadog(env: string) {
  try {
    datadogRum.init({
      applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
      clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
      site: import.meta.env.VITE_DATADOG_SITE,
      service: import.meta.env.VITE_DATADOG_SERVICE,
      env,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      defaultPrivacyLevel: "mask-user-input",
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
    });
  } catch (error) {
    console.error("Failed to initialize Datadog:", error);
  }
}
